import { FC } from 'react';
import { Text } from '@blueprint/ui';

import {
    ProfileMenuWrapper,
    ProfileWrapper,
    AccountMenuWrapper,
    StyledLogoIcon,
    SignedInLink,
    SignInLink,
    SavedLink,
    MyHomeLink
} from './ProfileMenu.styles';
import { ResetButtonLinkWithIcon } from '../../Header.styles';
import AccountMenu from '../AccountMenu';
import { SaveOutlineSmall, UserSmall, PropertiesSmall } from '@blueprint/icons';

type Props = {
    signInUrl: string;
};

const ProfileMenu: FC<Props> = ({ signInUrl }) => (
    <ProfileMenuWrapper>
        <ProfileWrapper data-testid="header-profile">
            <MyHomeLink>
                <ResetButtonLinkWithIcon
                    href="/my-home/"
                    variant="tertiary"
                    data-testid="header-profilemenu-my-home"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>my home"
                    data-myhome-button
                >
                    <div>
                        <PropertiesSmall width="20" height="20" />
                        <Text>My Home</Text>
                    </div>
                </ResetButtonLinkWithIcon>
            </MyHomeLink>
            <SavedLink data-is-logged-in="false">
                <ResetButtonLinkWithIcon
                    href="/signin/?page_after_login=/myaccount/favourites/&return_url=/myaccount/favourites/"
                    variant="tertiary"
                    data-testid="header-profilemenu-favourites"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>favourite properties>logged out"
                >
                    <div>
                        <SaveOutlineSmall width="20" height="20" />
                        <Text>Saved</Text>
                    </div>
                </ResetButtonLinkWithIcon>
            </SavedLink>
            <SavedLink data-is-logged-in="true">
                <ResetButtonLinkWithIcon
                    href="/myaccount/favourites/"
                    variant="tertiary"
                    data-testid="header-profilemenu-favourites"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>favourite properties"
                >
                    <div>
                        <SaveOutlineSmall width="20" height="20" />
                        <Text>Saved</Text>
                    </div>
                </ResetButtonLinkWithIcon>
            </SavedLink>
            <SignInLink data-is-logged-in="false">
                <ResetButtonLinkWithIcon
                    href={signInUrl}
                    variant="tertiary"
                    data-testid="header-profile-sign-in"
                    data-header-signin="/signin/?page_after_login={URL}&return_url={URL}&with_confirmation=true"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>sign in"
                >
                    <div>
                        <UserSmall width="20" height="20" />
                        <Text>Sign in</Text>
                    </div>
                </ResetButtonLinkWithIcon>
            </SignInLink>
            <SignedInLink data-is-logged-in="true">
                <ResetButtonLinkWithIcon
                    href="/myaccount/"
                    variant="tertiary"
                    data-testid="header-profile-account"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account"
                >
                    <div>
                        <StyledLogoIcon />
                        <Text>My Zoopla</Text>
                    </div>
                </ResetButtonLinkWithIcon>
                <AccountMenuWrapper>
                    <AccountMenu />
                </AccountMenuWrapper>
            </SignedInLink>
        </ProfileWrapper>
    </ProfileMenuWrapper>
);

export default ProfileMenu;
